"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Client-safe entry of the in-app-agent module. Server code must never be
// re-exported here — this barrel is imported by web client components and is
// covered by the client-bundle scan.
__exportStar(require("./schema"), exports);
__exportStar(require("./backgroundWatch"), exports);
__exportStar(require("./constants"), exports);
__exportStar(require("./ids"), exports);
__exportStar(require("./messages"), exports);
